export const SET_SINGLE_REQUEST = 'SET_SINGLE_REQUEST';